export default __webpack_public_path__ + "static/media/digital-tree.b1d2e583.svg";